var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTerms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7273 14.125V7.625C17.7273 6.73125 16.9909 6 16.0909 6H4.63636C3.73636 6 3 6.73125 3 7.625V14.125C3 15.0188 3.73636 15.75 4.63636 15.75H16.0909C16.9909 15.75 17.7273 15.0188 17.7273 14.125ZM16.0909 14.125H4.63636V7.625H16.0909V14.125ZM10.3636 8.4375C9.00545 8.4375 7.90909 9.52625 7.90909 10.875C7.90909 12.2238 9.00545 13.3125 10.3636 13.3125C11.7218 13.3125 12.8182 12.2238 12.8182 10.875C12.8182 9.52625 11.7218 8.4375 10.3636 8.4375ZM21 8.4375V17.375C21 18.2688 20.2636 19 19.3636 19H5.45455C5.45455 18.1875 5.45455 18.2688 5.45455 17.375H19.3636V8.4375C20.2636 8.4375 20.1818 8.4375 21 8.4375Z",
    fill: "#37288E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerms);
export default __webpack_public_path__ + "static/media/terms.10bc9e47.svg";
export { ForwardRef as ReactComponent };